import * as Chakra from '@chakra-ui/react'

export const Button = (props: Chakra.ButtonProps) => {
  return <Chakra.Button borderRadius="6px" colorPalette="gray" {...props} />
}
